import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { filter, take } from 'rxjs/operators';

@Component({
  selector: 'app-callback',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <div class="callback-container">
      @if (error) {
        <div class="error-card">
          <h4>Accès Refusé</h4>
          <p>{{ errorDescription }}</p>
          <a routerLink="/login" class="btn-primary">Retour à la connexion</a>
        </div>
      } @else {
        <div class="loading-card">
          <div class="spinner-border text-primary mb-3" role="status"></div>
          <p>Authentification Teréga en cours...</p>
        </div>
      }
    </div>
  `,
  styles: [`
    /* Styles spécifiques au composant */
    .callback-container {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 80vh;
    }
    .error-card, .loading-card {
      background: white;
      padding: 2rem;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      text-align: center;
      max-width: 480px;
    }
    .error-card h4 {
      color: #d9534f;
      margin-bottom: 1rem;
    }
    .btn-primary {
      display: inline-block;
      margin-top: 1rem;
      padding: 0.5rem 1rem;
      background: #0056b3;
      color: white;
      text-decoration: none;
      border-radius: 4px;
    }
  `]
})
export class CallbackComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private auth = inject(AuthService);

  error: string | null = null;
  errorDescription: string | null = null;

  ngOnInit(): void {
    // 1. Vérifier si Auth0 a renvoyé une erreur explicite dans les query params (ex: access_denied)
    const params = this.route.snapshot.queryParams;
    if (params['error']) {
      this.error = params['error'];
      this.errorDescription = params['error_description'] || 'Erreur d\'authentification Auth0.';
      return;
    }

    // 2. Attendre la fin du traitement automatique par le SDK Auth0
    this.auth.isLoading$.pipe(
      filter(loading => !loading),
      take(1)
    ).subscribe(() => {
      this.auth.isAuthenticated$.pipe(take(1)).subscribe(authenticated => {
        if (authenticated) {
          this.router.navigateByUrl('/courriers/dashboard');
        } else {
          this.auth.error$.pipe(take(1)).subscribe(err => {
            if (err?.message?.includes('Invalid state') || err?.message?.includes('query params')) {
              // Ignorer l'erreur de double consommation de state PKCE et rediriger vers l'app
              this.router.navigateByUrl('/courriers/dashboard');
            } else if (err) {
              this.error = 'Erreur Auth0';
              this.errorDescription = err.message || 'Échec du traitement du callback.';
            } else {
              this.router.navigateByUrl('/login');
            }
          });
        }
      });
    });
  }
}
